import { Component, OnInit, AfterViewInit, ChangeDetectorRef, Input, AfterContentChecked } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { CommunicationService } from "../services/communication.service";
import { ControllerService } from '../services/controller.service';
import * as compartments from "../../assets/smls/data/kha_compartments.json";
import { KHASystemService } from '../services/systems/kha-systems.service';
import { DatePipe } from '@angular/common';
import { ConfigService } from '../services/config.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ChitService } from '../services/chit.service';
import { TagService } from '../services/tag.service';

@Component({
  selector: 'app-ship-sidepanel',
  templateUrl: './ship-sidepanel.component.html',
  styleUrls: ['./ship-sidepanel.component.scss'],
  providers: [DatePipe]
})
export class ShipSidepanelComponent implements OnInit {
  compartList: any = [];
  panelWidth: any = '0px';
  slmsHandleToggleOpen: boolean = false;
  slmsPanelOpen: any = true;
  slmsControlPosition: any = 'Right';
  languageSelected: any = 'English';
  structHull: any = 'solid';
  structDecks: any = 'solid';
  structBulkheads: any = 'solid';
  structSections: any = 'solid';
  structOtherDecks: any = 'clear';
  deckList: any = [{ "name": '02', "deckSelected": false }, { "name": '01', "deckSelected": false }, { "name": '1', "deckSelected": false },
  { "name": 'M', "deckSelected": false }, { "name": '2', "deckSelected": false }, { "name": '3', "deckSelected": false }, { "name": '4', "deckSelected": false },
  { "name": '5', "deckSelected": false }, { "name": '6', "deckSelected": false }];
  // mode: ProgressSpinnerMode = 'determinate';
  search: any = '';
  selectedDeck: any = [];
  shipComp: any = {};
  shadowActive: boolean = false;
  broadcastSubs: any;
  compartmentList: any = [];
  currentComp = [];
  slms_mode;
  comps: any = [];
  showAllSystem: boolean = true;
  compartmentDeckList: any;
  filterComp: any = ['code', 'name'];
  sortComp: any;
  @Input() selectedKha: any = '';
  statusUpdated: any;
  sidepanelGroupTagpoint: any = [];
  layoutJson: any = [];
  groupJson: any = [];
  filterLayoutJson: any = [];
  selectedLayoutList: any = [];
  layoutCloseDetailData: any = [];
  showSelectedList: boolean = false;
  loadComparmentList: any = [];
  selectedId: any;
  selectedNotesId: any;
  layoutId: any;
  sysVisiable: boolean = true;
  @Input() set _testMode(v: any) {
    if (v.includes("game-mode")) {
      this.slmsHandleToggleOpen = false;
    }
  }
  appGameModeContrl: any;
  @Input() set appGameMode(v: any) {
    if (v == true) {
      this.showPanelOpen = false;
      this.showGroupPanelOpen = false;
      this.showReportPanelOpen = false;
      this.showStatusPanelOpen = false;
      this.appGameModeContrl = true;
      this.showGamePanel = true;
    }
    if (v == false) {
      this.appGameModeContrl = false;
      this.showGamePanel = false;
    }
  }
  @Input() compToggle: any;

  @Input() set appMode(v: any) {
    // this.broadcastInfo({ src: 'sidepanel', event: 'showhide-ruler', key: false, data: '' });
    // this.broadcastInfo({ src: 'sidepanel', event: 'showhide-fl', key: false, data: '' });
  }


  groupStatusColor = "#ffff"
  StatusColorValue = '#fff'
  // group & layout
  showPanelOpen: any = false;
  showGroupPanelOpen: any = false;
  shipHandleToggleOpen: boolean = false;
  shipGroupHandleToggleOpen: boolean = false;
  filterHandleToggleOpen: boolean = false;
  serviceHandleToggleOpen: boolean = false;
  controlPosition: any = 'Right';
  controlDPosition: any = 'Left';
  startDate: any = new Date();
  endDate: any = new Date();
  sortItem: any = 'startdate';
  searchLayout: any = "";
  searchGroup: any = "";
  filterLayoutKey: any = ['code', 'compartmentName', 'componentName', 'groupName', 'layoutName', 'statusName'];
  filterGroupKey: any = ['name'];
  currentActivityList: any = [];
  activitySelectedList: any = [];
  activityAll: any = true;
  activeShipList: any;
  parentCatListIdx: any;
  shipClassList: any = [];
  filterObjectKeys: any = ['layoutName'];
  filterGroupObjectKeys: any = [];
  defaultRangeDate = {
    "drawName": "Collection",
    "group": "Group",
    "status": "Status",
    "game": "Game"
  }
  sidepanelLayoutObject = [];
  sidepanelGroupObject = [];
  activeLayoutIndex: any;
  activeGroupIndex: any;
  isFilterAll: boolean = true;
  sidepanelLayoutData: any = [];
  sidepanelGroupData: any;
  hullAllStatus = 'solid';
  bulkheadsAllStatus = 'solid';
  sectionsAllStatus = 'solid';
  statusMenu = [
    { value: '#FF0000', name: 'BLOCKED' },
    { value: '#FFBF00', name: 'INPROGRESS' },
    { value: '#00FF00', name: 'COMPLETED' },
  ]
  statusFilter = []
  groupItems: any = ['Layout', 'Group', 'Stauts'];
  sortObjectKeys: any = ['code', 'compartmentName', 'componentName', 'groupName', 'layoutName', 'statusName'];
  sortlayoutItem: any = 'compartmentName';
  activitySelectStatus = true;
  activitySelectGroupAll = true;
  activitylayoutstaus = true;
  reportScreenList: any = [];
  showStatusPanelOpen: any = false;
  showGamePanel: any = false;
  shipStatusHandleToggleOpen: boolean = false;
  shipGameHandleToggleOpen: boolean = false;
  sidepanelStatusObject = [];
  sidepanelStatusData: any;
  filterStatusKey: any = ['name'];
  sortStatusItem: any = 'name';
  searchStatus: any = "";
  tagData: any;
  tagNotesDelete: any;
  smartDrawer: boolean = false;
  constructor(private domSanitizer: DomSanitizer, private cdref: ChangeDetectorRef, private datepipe: DatePipe, private khaConfig: KHASystemService, private cdRef: ChangeDetectorRef, private ctrlServe: ControllerService, private translate: TranslateService, private language: LanguageService, private CommunicationServ: CommunicationService, private configService: ConfigService, private chitService: ChitService, private tagServ: TagService,) {
    this.translate.addLangs(['en', 'fr']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    this.comps = this.ctrlServe.comps;
  }
  ngAfterViewChecked() {

    this.cdref.detectChanges();

  }
  /* * * * *
  * method for communicate event instance with data to access all components
  * * * * * */
  broadcastInfo(data: any) {
    this.CommunicationServ.getInstance().next(data);
  }

  getCompartments() {
    let dir = compartments['default'];
    let arr = Object.keys(dir);
    // this.findNewList(arr);
    this.compartmentList = [];
    arr.forEach((item) => {
      this.compartmentList.push({ name: dir[item], code: item, selected: false, visiable: false });
    })
    return this.compartmentList;
  }
  findNewList(e) {
    var newListData = [];
    let newList = ["01DA", "01DB0", "01DC0", "01DY1", "01DY3", "01DZ0", "01DZ2", "01EA", "01EB", "01FZ1", "01FZ2", "01GZ0", "01GZ1", "01JA1", "01JA2", "01JZ1", "01JZ2", "02EA", "02FZ", "1DA", "1DA2", "1DB", "1DC0", "1DC1", "1DC2", "1DX2", "1DY1", "1DY2", "1DY3", "1DZ0", "1DZ1", "1DZ2", "1EA0", "1EA1", "1EA3", "1EA5", "1EB0", "1EZ", "1FA", "1FZ0", "1FZ2", "1GA", "1GZ1", "1HA1", "1HA2", "1JA0", "1JA1", "1JA2", "1JA3", "1JZ1", "1JZ2", "2AA", "2AZ1", "2AZ2", "2BA", "2BZ0", "2BZ2", "2CA0", "2CA1", "2CA2", "2CB0", "2CB2", "2CY0", "2CY2", "2CY4", "2CZ", "2DA", "2DB2", "2DY2", "2DY4", "2DZ0", "2DZ2", "2DZ4", "2EA0", "2EA1", "2EA2", "2EA4", "2EB1", "2EZ2", "2FA0", "2FA1", "2FA2", "2FB0", "2FB1", "2FB2", "2FC1", "2FC2", "2FX1", "2FY1", "2FY2", "2FZ0", "2FZ1", "2FZ2", "2FZ3", "2FZ4", "2GA1", "2GA2", "2GA4", "2GB1", "2GB2", "2GZ1", "2GZ2", "2GZ3", "2GZ5", "2HA1", "2HA2", "2HA3", "2HZ0", "2HZ1", "2HZ2", "2JA0", "2JA1", "2JA2", "2JA3", "2JA4", "2JB0", "2JB2", "2JZ0", "2JZ1", "2JZ2", "2JZ3", "2KA0", "2KA1", "2KA2", "2KA4", "2KB0", "2KB1", "2KB2", "2KY1", "2KZ0", "2KZ1", "2KZ2", "2KZ3", "2LA0", "2LA1", "2LA2", "2LB1", "2LB2", "2LY0", "2LY1", "2LZ0", "2LZ1", "2LZ2", "2LZ3", "2LZ4", "2MA0", "2MA1", "2MA2", "2MZ0", "2MZ1", "2MZ2", "3BZ", "3CA", "3CB2", "3CZ0", "3CZ2", "3DA0", "3DA2", "3DY0", "3DZ0", "3DZ2", "3EA0", "3EA1", "3EA2", "3EY1", "3EY2", "3EZ1", "3FA1", "3FA2", "3FA3", "3FA4", "3FB2", "3FC2", "3FY2", "3FZ1", "3FZ2", "3FZ4", "3GA1", "3GA2", "3GA4", "3GB2", "3GB4", "3GZ0", "3GZ2", "3HA1", "3HA2", "3HB1", "3HZ0", "3HZ1", "3HZ2", "3HZ3", "3JA0", "3JA1", "3JA2", "3JA3", "3JA4", "3JZ0", "3JZ1", "3JZ2", "3KA0", "3KA1", "3KA2", "3KA4", "3KZ0", "3KZ2", "3LA0", "3LA1", "3LA2", "3LA4", "3LZ0", "3MA0", "3MA1", "3MA2", "3MA4", "3MZ0", "3MZ2", "4BZ", "4CA", "4CB2", "4CZ", "4DA", "4DB0", "4DC1", "4DC2", "4DY2", "4DZ0", "4DZ1", "4DZ2", "4JA0", "4JA1", "4JA2", "4JA4", "4JB2", "4JZ0", "4JZ2", "4KA0", "4KA1", "4KA2", "4KA4", "4KB2", "4KZ", "4L", "4LA0", "5DA1", "5DA2", "5DZ0", "5E-CASING", "5E", "5H-CASING", "5H", "5JA0", "6CB0", "6DA0", "6F-INTAKES", "6F-UPTAKES", "6F", "6G-CASING", "6G", "MAA", "MAZ", "ZA-C", "ZD", "ZE-G", "ZH-J", "ZK-M"];
    newList.forEach(element => {
      let idx = e.findIndex(ele => ele == element);
      if (idx == -1) {
        newListData.push(element)
      }
    });
    console.log("newList", newListData);
  }
  updateComprtmentList() {
    let deckFliter = [];
    if (this.selectedDeck.indexOf('0') > -1) {
      deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 2) == this.selectedDeck);
    } else {
      deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 1) == this.selectedDeck);
    }
    this.compartmentDeckList = deckFliter;
    this.compartmentList = deckFliter;
  }

  onChangeLanguage(langName) {
    if (langName == 'English') {
      this.language.changeLanguage('fr');
      this.translate.use('fr');
      this.languageSelected = 'French';
    }
    if (langName == 'French') {
      this.language.changeLanguage('en');
      this.translate.use('en');
      this.languageSelected = 'English';
    }
  }
  quizPanelOpen: any = false;
  quizHandleToggleOpen: any = false;
  quizList: any = [];
  reportTableList: any;
  ngOnInit() {
    this.broadcastSubs = this.CommunicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src == "slmsSidepanel") {
          if (data.event == "compartmentLoad") {
            this.loadComparmentList.push(data.data)
            var selectedlistdata = JSON.stringify(this.selectedDeck);
            var selectedlistdataList = JSON.parse(selectedlistdata)
            this.loadComparmentList.forEach(data => {
              var idx = this.selectedDeck.findIndex(eleme => eleme == data.code.substring(0, 1).toLowerCase())
              if (idx == -1) {
                selectedlistdataList.push(data.code.substring(0, 1).toLowerCase())
              }
            })
            this.onChangeDeck(selectedlistdataList)
            console.log('selected Deck', selectedlistdataList)
            this.loadCompartment(data.data)
          }
          if (data.event == "clearLoadCompartment") {
            this.clearCompartmentList(data.data);
            var selectedlistdata = JSON.stringify(this.selectedDeck);
            var selectedlistdataList = JSON.parse(selectedlistdata)
            this.selectedDeck.forEach(data => {
              var filterData = this.loadComparmentList.filter(eleme => data == eleme.code.substring(0, 1).toLowerCase())
              if (filterData.length == 1) {
                if (filterData[0].code.substring(0, 1).toLowerCase() != '2') {
                  var idx = selectedlistdataList.findIndex(ele => ele == filterData[0].code.substring(0, 1).toLowerCase())
                  selectedlistdataList.splice(idx, 1)
                }
              }
            })
            this.onChangeDeck(selectedlistdataList)
            var idxList = this.loadComparmentList.findIndex(ele => ele.code == data.data.code)
            this.loadComparmentList.splice(idxList, 1);
          }
          // if (data.event == "notesLoading") {
          //   if (data.data == true) {
          //     this.tagFlagCheck();
          //   }
          // }
        }
        if (data.src === "khaservice") {
          if (data.event === 'update-compartments') {
            this.shipComp['compList'] = data['data'];
            this.ctrlServe.shipComp['compList'] = this.shipComp['compList'];
            this.updateComprtmentList();
            this.sortCompartment('name');
          }
          if (data.event == "slmsSidePanel") {
            if (data.data) {
              let compList = Object.keys(data.data);
              this.activeCompartmentLoad(compList);
            }
          }
          // if (data.event == "updateActiveCard") {
          //   if (!this.layoutTagState) {
          //     if (data.data) {
          //       this.activeCard = data.data;
          //     }
          //   }

          // }
        }
        if (data.src === "sidepanel") {
          if (data.event == "filterToggle") {
            this.slmsHandleToggleOpen = data['data'];
            this.smartDrawer = data['data'];
          }
          if (data.event == "scoreBoard") {
            this.quizPanelOpen = true;
            this.quizHandleToggleOpen = true;
            this.shipReportHandleToggleOpen = false;
            this.shipGroupHandleToggleOpen = false;
            this.shipHandleToggleOpen = false;
            this.slmsHandleToggleOpen = false;
            this.shipStatusHandleToggleOpen = false;
            // this.showReportPanelOpen=false;
            this.quizList = data['data'];
          }
          if (data.event === 'updateSettigns') {
            // var updateSettigns = data['data'];
            // if (updateSettigns == true) {
            //   this.slmsHandleToggleOpen = false;
            // } else {
            //   this.slmsHandleToggleOpen = true;
            // }
          }
          if (data.event == 'deckValue') {
            this.onChangeDeck(data.data)
          }
          // if (data.event == 'deleteCompartmentNotes') {
          //   this.selectedNotesId = data.data;
          //   this.layoutId = data.key;
          // }
        }
        if (data.src === "kys") {
          // if (data.event === 'updateGroup') {
          //   this.sidepanelGroupObject = data.data;
          //   this.sidepanelGroupData = this.sidepanelGroupObject;
          //   console.log("updateGroup", data.data);
          //   if (this.activeGroupIndex && this.sidepanelGroupObject) {
          //     let idx = this.sidepanelGroupData.findIndex(e => e['_id'] == this.activeGroupIndex)
          //     if (idx > -1) {
          //       this.broadcastInfo({ src: 'sidepanel', event: 'groupList', data: this.sidepanelGroupObject[idx]['groupList'], key: "" });
          //     }
          //   }
          // }
        }
        if (data.src === "material") {
          // if (data.event === 'clearLayout') {
          //   delete this.activeLayoutId;
          //   delete this.activeLayoutIndex;
          //   delete this.activeCard;
          //   this.currentComp.forEach((e) => {
          //     setTimeout(() => {
          //       this.clearCompartment(e);
          //     }, 300)
          //   });
          // }
          // if (data.event === 'selectedLayoutIndex') {
          //   let idx = data['data'];
          //   this.broadcastInfo({ src: 'controlpanel', event: 'load-update-compartment', data: this.sidepanelLayoutData[idx], key: true });
          //   // }
          //   if (this.sidepanelLayoutData[idx]['tagPoints'].length > 0) {
          //     this.layoutTagState = true;
          //   }
          //   this.activeLayoutId = this.sidepanelLayoutData[idx]['_id'];
          //   this.activeLayoutIndex = idx;


          // }
          // if (data.event == "layoutTagClose") {
          //   let layoutData = data['data'];
          //   layoutData.tagShowState = false;
          //   this.khaConfig.showLayoutTag(layoutData, false);
          //   if (this.khaConfig.layoutTagList.length == 1) {
          //     this.layoutTagState = false;
          //   }
          //   // delete this.activeCard;
          // }
          // if (data.event == "layoutTagCloseActive") {
          //   // let layoutData = JSON.parse(this.selectedLayoutList)
          //   // this.khaConfig.showLayoutTag(this.sidepanelGroupTagpoint[this.activeCard], false);
          //   delete this.activeCard;

          // }
          // if (data.event == "layoutTagOpen") {
          //   let layoutData = data['data'];
          //   let status = data['status']
          //   this.khaConfig.showLayoutTag(layoutData, status);
          //   if (this.khaConfig.layoutTagList.length > 0) {
          //     this.layoutTagState = true;
          //   } else {
          //     this.layoutTagState = false;
          //   }
          // }
          if (data.event == 'deckToggle') {
            this.showHideStruct('Hull', 'none');
            this.showHideStruct('Bulkheads', 'none');
            this.showHideStruct('Sections', 'none');
            this.showHideStruct('OtherDecks', 'none');
          }
          if (data.event == 'clearLayoutList') {
            this.compartmentList.some(ele => ele.visiable == false && ele.selected == false);
            this.compartmentList.forEach(ele => {
              if (ele.visiable == true) {
                ele.visiable = false;
                ele.selected == false;
                this.clearCompartmentList(ele);
              }
            });
            // this.compartmentList.some(ele => ele.selected == false);
          }
        }
        // if (data.src === "main") {
        //   if (data.event == "deleteGroupData") {
        //     this.deleteGroupData();
        //   }
        //   if (data.event == "deleteLayoutData") {
        //     this.deleteLayoutData();
        //     this.broadcastInfo({ src: 'sidepanel', event: 'layoutActive', data:  [], key: true });
        //   }
        //   if (data.event == "deleteNotesData") {
        //     this.deleteNotesData();
        //   }
        //   if (data.event == "deleteStatusData") {
        //     this.deleteStatusData();
        //   }
        // }
        // if (data.src === "ship") {
        //   if (data.event == 'updateStatus') {
        //     this.sidepanelStatusData = data.data;
        //     this.sidepanelStatusObject = data.data;
        //   }
        //   if(data.event == 'layoutData'){
        //     this.sidepanelLayoutData = data.data;
        //     this.tagData = data.createNotes;
        //     this.reConstructTagJson();
        //   }
        //   if(data.event == 'layoutTagClose'){
        //     this.activeCard = undefined;
        //     delete this.activeTag;
        //     delete this.activeLayoutId;
        //   }
        // }
        if (data.event == 'updateGroup') {
          this.sidepanelGroupData = data.data;
          this.sidepanelGroupObject = data.data;
        }
        if (data.src === "khaservice") {
          if (data.event === 'update-compartments') {
            this.shipComp['compList'] = data['data'];
            this.ctrlServe.shipComp['compList'] = this.shipComp['compList'];
            this.updateComprtmentList();
            this.sortCompartment('name');
          }
          if (data.event == "slmsSidePanel") {
            if (data.data) {
              let compList = Object.keys(data.data);
              this.activeCompartmentLoad(compList);
            }
          }
          // if (data.event == "updateActiveCard") {
          //   if(!this.layoutTagState){
          //     if (data.data) {
          //       this.activeCard = data.data;
          //     }
          //   }
          // }
        }
      })
  }
  quizToggleOpenHanddle() {
    this.quizHandleToggleOpen = !this.quizHandleToggleOpen;
  }
  getScore() {
    let arr = this.quizList.filter(el => el.result === 1);
    let val = arr.length * 100 / this.quizList.length;
    return Math.round(val);
  }

  getCorrectAnsLen() {
    let arr = this.quizList.filter(el => el.result === 1);
    return arr.length;
  }

  getWrongAnsLen() {
    let arr = this.quizList.filter(el => el.result === 0);
    return arr.length;
  }
  getImageURL(e) {
    return this.domSanitizer.bypassSecurityTrustUrl(e)
  }
  pageIdx: any = 0;
  resetDeck() {
    this.showHideStruct('Hull', 'solid');
    this.showHideStruct('Bulkheads', 'solid');
    this.showHideStruct('Sections', 'solid');
    this.showHideStruct('OtherDecks', 'clear');
  }

  gameManager
  ngAfterViewInit() {
    this.shipComp['compList'] = this.getCompartments();
    this.ctrlServe.shipComp['compList'] = this.shipComp['compList'];
    this.compartmentDeckList = this.getCompartments();
    console.log("getCompartments", this.compartmentDeckList);
    if (this.compToggle) {
      if (this.compToggle['tab'] == 'kha') {
        this.onTabChanged({ index: 1 });
      }
      if (this.compToggle['tab'] == 'presets') {
        this.onTabChanged({ index: 2 });
        if (this.compToggle['selectMenu'] != '') {
          setTimeout(() => {
            this.processSystem(this.compToggle['selectMenu'])
          }, 1000);

        }
      }
      if (this.compToggle['tab'] == 'ladders') {
        this.onTabChanged({ index: 2 });
        if (this.compToggle['selectMenu'] != '') {
          setTimeout(() => {
            this.processSystem(this.compToggle['selectMenu']);
            this.showHideStruct('Hull', 'none');
            this.showHideStruct('Bulkheads', 'none');
            this.showHideStruct('Sections', 'none');
            this.showHideStruct('OtherDecks', 'none');
            this.broadcastInfo({ src: 'sidepanel', event: 'show-exit-work', data: true })
          }, 1000);

        }
      }
    }
    this.cdRef.detectChanges();
    this.onClearDeck();
  }

  getPanelwidth(e) {
    let elem = document.getElementById(e);
    return 'translateX(' + elem.offsetWidth + 'px)';
  }

  slmsToggleOpenHandle() {
    this.slmsHandleToggleOpen = !this.slmsHandleToggleOpen;
  }

  showHideStruct(label, state) {
    console.log(label, state);
    if (label.toLowerCase() == 'hull') {
      this.structHull = state;
    } else if (label.toLowerCase() == 'decks') {
      this.structDecks = state;
    } else if (label.toLowerCase() == 'bulkheads') {
      this.structBulkheads = state;
    } else if (label.toLowerCase() == 'sections') {
      this.structSections = state;
    } else if (label.toLowerCase() == 'otherdecks') {
      this.structOtherDecks = state;
    }
    let data = state === 'clear' ? 'transparent' : state;
    data = state === 'none' ? 'hide' : data;
    if (label.toLowerCase() === 'otherdecks') {
      this.broadcastInfo({ src: 'sidepanel', event: 'toggle-otherdecks-state', data, key: label });
    } else {
      this.broadcastInfo({ src: 'sidepanel', event: 'toggle-struct-state', data, key: label });
    }
  }


  onChangeDeck(value) {
    let idx = this.selectedDeck.findIndex(e => e === value);
    let index = this.deckList.findIndex(obj => obj.name == value);

    if (idx > -1) {
      this.selectedDeck.splice(idx, 1);
      if (index > -1) {
        this.deckList[index].deckSelected = false;
      }
    } else {
      this.selectedDeck.push(value);
      if (index > -1) {
        this.deckList[index].deckSelected = true;
      }
    }
    this.activeSelectedDeck();
  }

  changeDeck(value) {
    this.selectedDeck = value;
    var deckFliter = [];
    let deckMultiple = []
    this.selectedDeck.forEach(ele => {
      if (ele.indexOf('0') > -1) {
        deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 2).toLowerCase() == ele.toLowerCase());
        if (ele.toLowerCase() == "01") {
          let addComp = []
          addComp = this.shipComp['compList'].filter(element => element.code.includes("ZD") || element.code.includes("ZH-J"));
          console.log("01", addComp);
          deckFliter = deckFliter.concat(addComp);
        }
      } else {
        deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 1).toLowerCase() == ele.toLowerCase());
        if (ele.toLowerCase() == "1") {
          let addComp = []
          addComp = this.shipComp['compList'].filter(element => element.code.includes("ZA-C") || element.code.includes("ZE-G") || element.code.includes("ZK-M"));
          console.log("01", addComp);
          deckFliter = deckFliter.concat(addComp);
        }
      }
      if (deckMultiple.length > 0) {
        deckMultiple = deckMultiple.concat(deckFliter)
      } else {
        deckMultiple = deckFliter;
      }
    });
    console.log(deckMultiple)
    this.compartmentDeckList = deckMultiple;
    this.compartmentList = deckMultiple;
    this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: value, key: "" });
  }

  onClearDeck() {
    this.selectedDeck = [];
    let deckFliter = [];
    let deckMultiple = []
    this.selectedDeck.forEach(ele => {
      if (ele.indexOf('0') > -1) {
        deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 2).toLowerCase() == ele.toLowerCase());
      } else {
        deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 1).toLowerCase() == ele.toLowerCase());
      }
      if (deckMultiple.length > 0) {
        deckMultiple = deckMultiple.concat(deckFliter)
      } else {
        deckMultiple = deckFliter;
      }
    });
    console.log(deckMultiple)
    this.compartmentDeckList = deckMultiple;
    this.compartmentList = deckMultiple;
    this.search = "";
    if (this.search != '') {
      this.searchValue();
    }
    this.search = "";
    this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: this.selectedDeck, key: "" });
    this.deckSelectionCheckClear()
    // if (this.currentComp.length > 0) {
    //   this.currentComp.forEach((e) => {
    //     this.clearCompartment(e);
    //   })
    // }
    // if(this.khaConfig.matrixDataList){
    //   this.khaConfig.matrixDataList.forEach(element => {
    //     if(element.name !="otherDeck"){
    //       element.visible = false;
    //     }
    //     this.selectedDeck.forEach(ele => {
    //       if (element.name == ele) {
    //         element.visible = true;
    //       }
    //     });
    //   });
    // }  
  }
  deckSelectionCheckClear() {
    if (this.shipComp['compList'].length > 0) {
      this.shipComp['compList'].forEach(element => {
        if (element.selected) {
          let idx = this.compartmentList.findIndex(e => e.code == element.code);
          if (idx == -1) {
            this.clearCompartmentList(element);
          }
        }
      });
    }
  }
  shadowAdd(e) {
    this.shadowActive = e.checked
  }

  /* *
  * method for show/hide sub systems
  * */
  showFocusSubSystem(s) {
    var subSystemActiveList = this.ctrlServe.showSysComp
    var subSystemActive = subSystemActiveList[this.selectedKha];
    // delete this.khaConfig.layoutName;
    if (!subSystemActive) return;
    subSystemActive.forEach((item, index) => {
      if (item == s) {
        this.broadcastInfo({ src: 'controlpanel', event: 'focusSubSystem', data: 'true', key: s });
      }
    })
  }

  showHideSubSystem(e, s) {
    this.ctrlServe.selectedSysComp = [];
    this.ctrlServe.updateSysComps(s, e.checked);
    this.broadcastInfo({ src: 'controlpanel', event: 'showhidesubsystem', data: e.checked, key: s });
    this.checkSubSystemStatus();
  }

  checkSubSystemStatus() {
    let hideAll, hideSys, showAll;
    const idx = this.comps.findIndex(el => el.component.toLowerCase() === 'kha');
    this.comps[idx]["compList"].forEach(item => {
      if (item['key'] === this.selectedKha.split(" ").join("").toLowerCase()) {
        hideSys = item['systemList'].some(sys => sys['status'] == 'inactive');
        hideAll = item['systemList'].every(sys => sys['status'] == 'inactive');
        showAll = item['systemList'].every(sys => sys['status'] == 'active');
      }
    })
    this.showAllSystem = hideSys ? false : true;
    if (hideAll) {
      this.showAllSystems({ checked: false });
    }
    if (showAll) {
      setTimeout(() => {
        this.showAllSystems({ checked: true });
      }, 1000);
    }
  }
  // loadViewCompartment(s) {
  //   let show = true;
  //   this.shipComp['compList'].forEach(sys => {
  //     if (sys['code'] == s.code) {
  //       sys.selected = true;
  //       show = true;
  //       if (this.currentComp.length > 0) {
  //         let idx = this.currentComp.findIndex(e => e.code == s.code);
  //         if (idx == -1) {
  //           this.currentComp.push(s);
  //         }
  //       } else {
  //         this.currentComp.push(s);
  //       }
  //       // this.currentComp = show ? s : "";
  //     } else {
  //       // if (!this.slms_mode) {
  //       //   sys.selected = false;
  //       // }
  //     }
  //   });
  //   if (!this.slms_mode) {
  //     this.resetWallmode();
  //   }
  //   this.broadcastInfo({ src: 'controlpanel', event: 'loadcompartment', data: s, key: show });
  // }
  activeCompartmentLoad(list) {
    list.forEach(sys => {
      let idx = this.shipComp['compList'].findIndex(e => e.code == sys);
      if (idx > -1) {
        this.currentComp.push(this.shipComp['compList'][idx]);
        this.shipComp['compList'][idx].selected = true;
        this.shipComp['compList'][idx].visiable = true;
      }
    });
  }
  loadCompartmentData(e, s) {
    if (e.checked) {
      this.loadCompartment(s);
    } else {
      this.closeCompartmentList(s);
    }
  }
  loadCompartment(s) {
    let show = true;
    let returnValue = false;
    this.shipComp['compList'].forEach(sys => {
      if (sys['code'] == s.code) {
        sys.selected = true;
        sys.visiable = true
        show = true;
        if (this.currentComp.length > 0) {
          let idx = this.currentComp.findIndex(e => e.code == s.code);
          if (idx == -1) {
            this.currentComp.push(s);
          }
          // else{
          //   console.log(s);
          //   returnValue=true;

          // }
        } else {
          this.currentComp.push(s);
        }
        // this.currentComp = show ? s : "";
      } else {
        // if (!this.slms_mode) {
        //   sys.selected = false;
        // }
      }
    });
    // if(returnValue){
    //   this.clearCompartment(s);
    //   return;
    // }
    if (!this.slms_mode) {
      this.resetWallmode();
    }
    this.broadcastInfo({ src: 'controlpanel', event: 'loadcompartment', data: s, key: show });
  }
  resetWallmode() {
    this.shipComp['compList'].forEach(sys => {
      if (sys['wallmode']) {
        sys.wallmode = !sys.wallmode;
      }
    });
  }
  isActiveComparment() {
    let showSelectedValue = this.compartmentList.some(ele => ele.visiable == true);
    return showSelectedValue
  }
  /* *
  * method for showHideCompartmentWall
  * */
  showHideCompartmentWall(sys) {
    if (this.currentComp.length > 0) {
      sys.wallmode = !sys.wallmode;
      this.broadcastInfo({ src: 'controlpanel', event: 'showhidecompartmentwall', data: !sys.wallmode, key: [sys.code] });
    }
  }

  clearCompartment(sys) {
    if (sys) {
      sys.selected = false;
      delete this.khaConfig.compartments_store[sys.code];
      if (this.currentComp.length > 0) {
        let idx = this.currentComp.findIndex(e => e.code == sys.code);
        if (idx > -1) {
          this.currentComp.splice(idx, 1);
        }
      }
      if (this.compartmentList.length > 0) {
        let idx = this.compartmentList.findIndex(e => e.code == sys.code);
        if (idx > -1) {
          this.compartmentList[idx]['selected'] = false;
          this.compartmentList[idx]['visiable'] = false;
        }
      }
      // console.log("clearCompartment ", this.currentComp);
      this.broadcastInfo({ src: 'sidepanel', event: 'clearCompartment', data: sys.code, key: "" });
    }
  }
  clearCompartmentList(sys) {
    var compState = true;
    if (this.khaConfig.layoutData) {
      if (this.khaConfig.layoutData['compartments']) {
        let idx = this.khaConfig.layoutData['compartments'].findIndex(e => e.code == sys.code);
        if (idx > -1) {
          compState = false;
        }
      }

    }
    if (this.khaConfig.groupList && this.khaConfig.groupMode) {
      let idx = this.khaConfig.groupList.findIndex(e => e.code == sys.code);
      if (idx > -1) {
        compState = false;
      }
    }
    if (compState) {
      if (sys) {
        delete this.khaConfig.compartments_store[sys.code];
        sys.selected = false;
        if (this.currentComp.length > 0) {
          let idx = this.currentComp.findIndex(e => e.code == sys.code);
          if (idx > -1) {
            this.currentComp.splice(idx, 1);
          }
        }
        if (this.compartmentList.length > 0) {
          let idx = this.compartmentList.findIndex(e => e.code == sys.code);
          if (idx > -1) {
            this.compartmentList[idx]['selected'] = false;
            this.compartmentList[idx]['visiable'] = false;
          }
        }
        console.log("clearCompartment ", this.currentComp);
        this.broadcastInfo({ src: 'sidepanel', event: 'clearCompartment', data: sys.code, key: "" });
      }
    }
  }
  filterCompartment(e) {
    this.filterComp = e;
  }

  sortCompartment(e) {
    this.sortComp = e;
    if (this.compartmentList.length > 0) {
      this.compartmentList.sort((a, b) => a[e] < b[e] ? -1 : a[e] > b[e] ? 1 : 0);
    }
  }
  searchDeckSelection(compartmentList) {
    var deckSelected = [];

    compartmentList.forEach(element => {
      if (element['code'] == "--") {
        element['code'] = element['name'];
      }
      if (element['code'].substring(0, 1).indexOf('0') > -1) {
        if (deckSelected.length > 0) {
          var deck = false;
          deckSelected.forEach((ele) => {
            if (ele.length == 1) {
              if (ele.substring(0, 1).toLowerCase() == element['code'].substring(0, 1).toLowerCase()) {
                deck = true;
              }
            }
            if (ele.length == 2) {
              if (ele.substring(0, 2).toLowerCase() == element['code'].substring(0, 2).toLowerCase()) {
                deck = true;
              }
            }
          })
          if (!deck) {
            deckSelected.push(element['code'].substring(0, 2).toUpperCase());
          }
        } else {
          deckSelected.push(element['code'].substring(0, 2).toUpperCase());
        }
      } else {
        if (element['code'].substring(0, 1).toLowerCase() == "z") {
          var deck = false;
          var otherDeck = (element['code'].substring(0, 2).toLowerCase() == 'za' || element['code'].substring(0, 2).toLowerCase() == 'zk' || element['code'].substring(0, 2).toLowerCase() == 'zk') ? '1' : (element['code'].substring(0, 2).toLowerCase() == 'zd' || element['code'].substring(0, 2).toLowerCase() == 'zh') ? '01' : '';
          if (otherDeck) {
            deckSelected.forEach((ele) => {
              if (ele.length == 1) {
                if (ele.substring(0, 1).toLowerCase() == otherDeck) {
                  deck = true;
                }
              }
              if (ele.length == 2) {
                if (ele.substring(0, 2).toLowerCase() == otherDeck) {
                  deck = true;
                }
              }
            })
            if (!deck) {
              deckSelected.push(otherDeck);
            }
          }

        } else {
          if (deckSelected.length > 0) {
            var deck = false;
            deckSelected.forEach((ele) => {
              if (ele.length == 1) {
                if (ele.substring(0, 1).toLowerCase() == element['code'].substring(0, 1).toLowerCase()) {
                  deck = true;
                }
              }
              if (ele.length == 2) {
                if (ele.substring(0, 2).toLowerCase() == element['code'].substring(0, 2).toLowerCase()) {
                  deck = true;
                }
              }
            })
            if (!deck) {
              deckSelected.push(element['code'].substring(0, 1).toUpperCase());
            }
          } else {
            deckSelected.push(element['code'].substring(0, 1).toUpperCase());
          }
        }

      }
    });
    // console.log("deckSelected", deckSelected,this.compartmentList,compartmentList);
    this.changeDeck(deckSelected);


    // if (this.currentComp.length > 0) {
    //   this.currentComp.forEach((e) => {
    //     this.clearCompartment(e);
    //   })
    // }
    if (deckSelected.length > 0) {
      this.selectedDeck = deckSelected;
    } else {
      this.selectedDeck = [];
    }
    this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: this.selectedDeck, key: "" });
    console.log("deckSelected", deckSelected, this.compartmentList, compartmentList);
  }
  // searchDeckSelection() {
  //   var deckSelected;
  //   if (this.search == '') {
  //     this.searchValue();
  //   } else {
  //     if (isNaN(this.search[0]) && this.search[0].toLowerCase() != 'm') {
  //       this.searchValue();
  //     } else {
  //       if (this.search[0].indexOf('0') > -1) {
  //         if (this.search.length > 1) {
  //           deckSelected = this.selectedDeck == this.search.substring(0, 2).toLowerCase() ? this.selectedDeck : this.search.substring(0, 2);
  //         }
  //       } else {
  //         deckSelected = this.selectedDeck == this.search.substring(0, 1).toLowerCase() ? this.selectedDeck : this.search.substring(0, 1);
  //       }
  //       if (deckSelected) {
  //         let idx = this.deckList.findIndex(e => e.toLowerCase() == deckSelected.toLowerCase());
  //         if (idx > -1) {
  //           this.changeDeck(deckSelected.toUpperCase());
  //           this.searchValue();
  //         }
  //       }
  //     }
  //   }
  // }

  searchValue() {
    var filterData = [];
    var compartment;
    if (this.selectedDeck != '') {
      compartment = this.compartmentDeckList;
    } else {
      compartment = this.shipComp['compList'];
    }
    if (this.search == '') {
      // this.selectedDeck = ['2'];
      compartment = this.compartmentDeckList;
      filterData = compartment;
      // if (this.currentComp.length > 0) {
      //   this.currentComp.forEach((e) => {
      //     this.clearCompartment(e);
      //   })
      // }
      // this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: this.selectedDeck, key: "" });
    } else {
      if (compartment.length > 0) {
        for (let i = 0; i < compartment.length; i++) {
          this.filterComp.forEach((key) => {
            if (compartment[i][key].toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
              const found = filterData.some(ship => ship.code === compartment[i]['code'])
              if (!found) {
                filterData.push(compartment[i]);
              }
            }
          })
        }
      }

    }
    this.compartmentList = filterData;
    // this.searchDeckSelection();
    this.sortCompartment('code');
    // this.khaConfig.matrixDataList.forEach(element => {
    //   if(element.name !="otherDeck"){
    //     element.visible = false;
    //   }
    //   this.selectedDeck.forEach(ele => {
    //     if (element.name == ele) {
    //       element.visible = true;
    //     }
    //   });
    // });
  }

  searchClear() {
    this.search = '';
    // this.selectedDeck = ['2'];
    if (this.selectedDeck.length > 0) {
      this.compartmentList = this.compartmentDeckList;
    } else {
      this.compartmentList = this.shipComp['compList'];
    }
    this.sortCompartment('code');
    // if (this.currentComp.length > 0) {
    //   this.currentComp.forEach((e) => {
    //     // this.clearCompartment(e);
    //   })
    // }
    // this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: this.selectedDeck, key: "" });
    // this.khaConfig.matrixDataList.forEach(element => {
    //   if(element.name !="otherDeck"){
    //     element.visible = false;
    //   }
    //   this.selectedDeck.forEach(ele => {
    //     if (element.name == ele) {
    //       element.visible = true;
    //     }
    //   });
    // });
  }


  expandCurrent(i) {
    const idx = this.comps.findIndex(el => el.component.toLowerCase() === 'kha');
    this.onChangekhaComp(this.comps[idx].compList[i]);
  }

  /* * *
  * method for change kha comp
  * * */
  onChangekhaComp(comp) {
    if (comp) {
      if (this.selectedKha) {
        if (this.selectedKha === comp['system'].split(" ").join("").toLowerCase()) {
          return
        }
      }
      this.selectedKha = comp['system'].split(" ").join("").toLowerCase();
      this.ctrlServe.selectedKha = this.selectedKha.split(" ").join("").toLowerCase();
      this.broadcastInfo({ src: 'sidepanel', event: 'changeshipcomp', data: this.selectedKha, comp: [] });
    }
  }

  showAllSystems(e) {
    let boo = e.checked
    this.showAllSystem = boo;
    this.broadcastInfo({ src: 'sidepanel', event: 'showhide-all-systems', data: boo, key: "" });
    if (!boo) {
      this.resetSubSystems();
    }
  }

  resetSubSystems() {
    this.broadcastInfo({ src: 'sidepanel', event: 'reset-sub-systems', data: '', key: "" });
  }

  currentTab = "compartment";
  selectedTabIndex = 1;
  onTabChanged($event) {
    if ($event['index'] == "0") {
      // if (this.currentComp.length > 0) {
      //   this.currentComp.forEach((e) => {
      //     setTimeout(() => {
      //       this.clearCompartment(e);
      //     })
      //   })
      // }
      // this.clearAllPresetSystem();
    }

    this.selectedTabIndex = $event['index'];
    let key = $event['index'] == 0 ? 'system' : 'compartment';
    this.currentTab = key;

    if (key === 'compartment') {
      this.selectedKha = "";
      this.showAllSystem = true;
    }
    this.broadcastInfo({ src: 'sidepanel', event: 'reset-views', data: '', key: key });
  }
  // layout and group functions

  // ToggleOpenHanddle() {
  //   this.shipHandleToggleOpen = !this.shipHandleToggleOpen;
  //   if (!this.shipHandleToggleOpen) {
  //     if (window.innerWidth > 541) {
  //     }
  //   }
  //   if (!this.shipHandleToggleOpen) {
  //     var elem = document.getElementsByClassName('side_panel');
  //     elem[0].classList.remove('open');
  //   } else {
  //   }
  // }
  showReportPanelOpen: any = true;
  shipReportHandleToggleOpen: any = false;
  ToggleReportOpenHanddle() {
    this.shipReportHandleToggleOpen = !this.shipReportHandleToggleOpen;
    if (!this.shipReportHandleToggleOpen) {
      if (window.innerWidth > 541) {
      }
    }
    if (!this.shipReportHandleToggleOpen) {
      var elem = document.getElementsByClassName('side_panel');
      elem[0].classList.remove('open');
    } else {
    }
  }
  ToggleGroupOpenHanddle() {
    this.shipGroupHandleToggleOpen = !this.shipGroupHandleToggleOpen;
    if (!this.shipGroupHandleToggleOpen) {
      if (window.innerWidth > 541) {
      }
    }
    if (!this.shipGroupHandleToggleOpen) {
      var elem = document.getElementsByClassName('side_panel');
      elem[0].classList.remove('open');
    } else {
    }
  }
  getPanelwidthWindow(e) {
    if (e == 'filterPanel') {
      let rawElem = document.getElementById('shipPanel');
      width = rawElem.offsetWidth;
      return width + 'px';
    } else {
      let elem = document.getElementById(e);
      if (elem != null) {
        var width = elem.offsetWidth;
        if (this.filterHandleToggleOpen) {
          let rawElem = document.getElementById('filterPanel');
          width += rawElem.offsetWidth;
        }
        if (this.serviceHandleToggleOpen) {
          let rawElem = document.getElementById('filterPanel');
          width += rawElem.offsetWidth;
        }
        if (e == 'toolPanel' || e == 'shipPanel_2' || e == 'servicesPanel' || e == 'cautionPanel') {
          let rawElem = document.getElementById(e);
          width = rawElem.offsetWidth;
          return width + 'px';
        }
        if (e == 'WFMPanel' || e == 'libPanel') {
          let rawElem = document.getElementById(e);
          width = rawElem.offsetWidth;
        }

        return 'translateX(' + width + 'px)';
      } else {
        return 'translateX(0px)';
      }

    }
  }
  alphabetOrder(data, key) {
    data.sort((a: any, b: any) => {
      if (a[key] < b[key]) {
        return -1;
      } else if (a[key] > b[key]) {
        return 1;
      } else {
        return 0;
      }
    });
    return data;
  }
  regEx(location) {
    return location;
  }
  regExReverse(location) {
    return location.replace(/\//g, "_").replace(/\s/g, '');
  }

  //  Class mapping ship meta data

  mappingCategory() {
    this.shipClassList = [];
    if (this.sidepanelLayoutData.length > 0) {
      this.sidepanelLayoutData.forEach(element => {
        if (this.shipClassList.indexOf(element.class) == -1) {
          this.shipClassList.push(element.class);
        }
      });
    }
  }
  getFilterKey(listData) {
    this.filterObjectKeys = [];
    this.filterObjectKeys = Object.keys(listData);
    // this.filterKey = this.filterObjectKeys;
  }
  filterToggle() {
    this.filterHandleToggleOpen = !this.filterHandleToggleOpen;
    if (window.innerWidth < 541) {
      this.ToggleOpenHanddle()
    }
  }
  // layout and group functions
  ToggleOpenHanddle() {
    this.shipHandleToggleOpen = !this.shipHandleToggleOpen;
    if (this.filterHandleToggleOpen)
      this.filterHandleToggleOpen = false;
    if (!this.shipHandleToggleOpen) {
      if (window.innerWidth > 541) {
      }
    }
    if (!this.shipHandleToggleOpen) {
      var elem = document.getElementsByClassName('side_panel');
      elem[0].classList.remove('open');
    } else {
    }
  }
  // layoutTagState: any = false;
  // activeLayoutId: any;
  // activeLayout(event, i, layout, tag) {
  //   // this.khaConfig.loadedCompartment
  //   if (tag == false) {
  //     delete this.khaConfig.showLayoutTagData;
  //     delete this.khaConfig.showLayoutTagDataIdx;
  //   }
  //   let layoutId = layout;
  //   this.khaConfig.storedMeshComps = [];
  //   this.khaConfig.hideHighlightSelection();
  //   this.khaConfig.clearCutOuts();
  //   this.khaConfig.clearPointer();
  //   this.khaConfig.clearSections();
  //   console.log('layout', layout)
  //   // if (this.activeCardFlag) {
  //   //   this.activeCardFlag = false;
  //   // } else {
  //   //   delete this.khaConfig.showLayoutTagData;
  //   // }
  //   var layoutIDx = this.sidepanelLayoutData.findIndex(obj => obj._id == layout);
  //   this.sidepanelLayoutData[layoutIDx]['compartments'] = this.khaConfig.getLayoutCompartment(this.sidepanelLayoutData[layoutIDx]);
  //   layout = this.sidepanelLayoutData[layoutIDx];
  //   this.khaConfig.layoutTagList = [];
  //   this.layoutTagState = true;
  //   if (event) {
  //     if (event.target.classList.contains('delete_icon')) {
  //       return
  //     }
  //   }

  //   if (!layout) return;
  //   // this.resetDeck();
  //   delete this.activeGroupIndex;
  //   delete this.activeLayoutId;
  //   // this.onClearDeck();

  //   if (this.activeLayoutIndex == i) {
  //     delete this.activeLayoutIndex;
  //     delete this.activeLayoutId;
  //     if (this.currentTab === "system") {
  //       this.onTabChanged({ index: 1 });
  //     }
  //     this.layoutTag(this.activeLayoutIndex)
  //     this.currentComp.forEach((e) => {
  //       setTimeout(() => {
  //         this.clearCompartment(e);
  //       }, 300)
  //     });
  //     this.layoutCloseDetailData = [];
  //     this.broadcastInfo({ src: 'controlpanel', event: 'clear-layout-window', data: "", key: true });
  //   } else {
  //     this.activeLayoutIndex = i;
  //     this.activeLayoutId = layoutId;
  //     if (this.currentTab === "system") {
  //       this.onTabChanged({ index: 1 });
  //     }
  //     this.currentComp.forEach((e) => {
  //       setTimeout(() => {
  //         this.clearCompartment(e);
  //       }, 300)
  //     });

  //     setTimeout(() => {
  //       this.resetWallmode();
  //       this.currentComp = [];
  //       layout['compartments'].forEach(item => {
  //         const found = this.currentComp.some(el => el.code == item.code);
  //         if (!found) {
  //           let idx = this.shipComp['compList'].findIndex(e => e.code == item.code);
  //           if (idx > -1) {
  //             this.shipComp['compList'][idx]['selected'] = true;
  //             this.shipComp['compList'][idx]['visiable'] = true;
  //             this.currentComp.push(this.shipComp['compList'][idx]);
  //           }
  //         }
  //       });
  //       if (event) {
  //         if (event.target.classList.contains('l-pos') || event.target.classList.contains('spanHead')) {
  //           layout['tagPoints'].forEach(ele => {
  //             let idx = this.sidepanelGroupTagpoint.findIndex(e => e.id == ele['id']);
  //             this.sidepanelGroupTagpoint[idx]['tagShowState'] = true;

  //           });
  //         }
  //       }
  //       console.log("activeLayout", this.sidepanelGroupTagpoint);
  //       this.selectedLayoutList = JSON.stringify(layout);
  //       this.layoutCloseDetailData = JSON.parse(this.selectedLayoutList);
  //       var tagpoint = this.layoutCloseDetailData['tagPoints']
  //       var tagCom = tagpoint
  //       // this.layoutCloseDetailData.forEach(lay => {
  //       // lay['tagPoints'].forEach(tagpoint => {
  //       tagCom.forEach(tagcom => {
  //         var tag = tagcom.tagComments
  //         // if (tagcom.tagComments) {
  //         // tagcom['tagComments'].forEach(tag => {
  //         if (tag && tag.statusId) {
  //           let filteredStatus = this.sidepanelStatusData.filter(m => m._id == tag.statusId);
  //           var statusData = filteredStatus[0]
  //           if (statusData != undefined) {
  //             tag.statusName = statusData.name;
  //             tag.statusColor = statusData.value;
  //           }
  //           if (statusData == undefined) {
  //             tag.statusName = '';
  //             tag.statusColor = '';
  //           }
  //         }
  //         // });
  //         // }
  //       });
  //       // });
  //       // });
  //       this.broadcastInfo({ src: 'controlpanel', event: 'load-mutiple-compartment', data: layout, key: true });

  //       if (layout['tagPoints'].length > 0) {
  //         if (layout['compartments'].length > 0) {
  //           this.searchDeckSelection(layout['compartments']);
  //         } else {
  //           if (layout['compartments'].length > 0) {
  //             this.searchDeckSelection(layout['compartments']);
  //           }
  //         }

  //       }

  //     }, 1000);
  //     // this.tagFlagCheck();
  //   }
  // }

  // activeLayout( i, layout,item) {
  //   this.activeLayoutIndex=i;
  //   this.activeLayoutId = layout
  //   if(this.sidepanelGroupTagpoint[this.activeCard]){
  //     this.khaConfig.showLayoutTag(this.sidepanelGroupTagpoint[this.activeCard], false);
  //     delete this.activeCard
  //     delete this.activeLayoutId
  //     delete this.activeTag
  //   }
  //   this.broadcastInfo({ src: 'sidepanel', event: 'updateCollectionData', data: item });
  //   this.broadcastInfo({ src: 'sidepanel', event: 'layoutActive', data:  this.sidepanelLayoutData[this.activeLayoutIndex],tagShow: this.sidepanelGroupTagpoint, key: true });
  // }

  // tagFlagCheck() {
  //   this.activeLayoutTag;
  //   this.activeLayoutTagCard;
  //   this.activeCard = this.activeCards;
  //   // setTimeout(() => {
  //   if (this.sidepanelLayoutData.length > 0) {
  //     this.sidepanelLayoutData.forEach(element => {
  //       if (element['_id'] == this.activeLayoutTag) {
  //         element['tagPoints'].forEach(ele => {
  //           if (ele['id'] != this.activeLayoutTagCard['id']) {
  //             let idx = this.sidepanelGroupTagpoint.findIndex(e => e.id == this.activeLayoutTagCard['id']);
  //             if (idx > -1) {
  //               this.sidepanelGroupTagpoint[idx]['tagShowState'] = false;
  //               this.broadcastInfo({ src: 'material', event: 'layoutTagClose', data: ele });
  //             } else {
  //               this.sidepanelGroupTagpoint[idx]['tagShowState'] = true;
  //             }
  //           } else {
  //             let idx = this.sidepanelGroupTagpoint.findIndex(e => e.id == this.activeLayoutTagCard['id']);
  //             this.sidepanelGroupTagpoint[idx]['tagShowState'] = true;
  //           }
  //         });
  //       }
  //     });
  //     console.log("layoutLoadFromNote", this.sidepanelGroupTagpoint);
  //   }
  //   // }, 2000);
  // }
  // layoutTagHide(i) {
  //   this.layoutTagState = false;
  //   if (this.sidepanelLayoutData.length > 0 && this.sidepanelLayoutData[i]) {
  //     if (this.sidepanelLayoutData[i]['tagPoints'].length > 0) {
  //       this.sidepanelLayoutData[i]['tagPoints'].forEach(element => {
  //         element.tagShowState = this.layoutTagState;
  //         this.khaConfig.showLayoutTag(element, this.layoutTagState);
  //       });

  //     }
  //   }
  //   if (this.layoutTagState == false) {
  //     this.activeCard = undefined;
  //   }

  // }
  // layoutTag(i) {
  //   this.layoutTagState = !this.layoutTagState;
  //   if (this.sidepanelLayoutData.length > 0 && this.sidepanelLayoutData[i]) {
  //     if (this.sidepanelLayoutData[i]['tagPoints'].length > 0) {
  //       this.sidepanelLayoutData[i]['tagPoints'].forEach(element => {
  //         element.tagShowState = this.layoutTagState;
  //         this.khaConfig.showLayoutTag(element, this.layoutTagState);
  //       });

  //     }
  //   }
  //   if (this.layoutTagState == false) {
  //     this.activeCard = undefined;
  //   }

  // }
  selectedLayoutDeleteData = {}
  selectedGroupDeleteData = {};
  changeMatrixHull(i, e) {
    this.khaConfig.matrixDataList.forEach((element, idx) => {
      if (idx == i && element.name != "otherDeck") {
        element.hull = e;
        var name = element.name;
        // this.khaConfig.applyState_Hull(e, name, this.khaConfig.matrixDataList);
      }
      if (idx == i && element.name == "otherDeck") {
        element.hull = e;
        this.showHideStruct('otherDecks', e)
      }
    });
  }
  changeMatrixBulkheads(i, e) {
    this.khaConfig.matrixDataList.forEach((element, idx) => {
      if (idx == i) {
        element.bulkheads = e;
        var name = element.name;
        // this.khaConfig.applyState_Bulkheads(e, name,this.khaConfig.matrixDataList)
      }
    });
  }
  changeMatrixSections(i, e) {
    this.khaConfig.matrixDataList.forEach((element, idx) => {
      if (idx == i) {
        element.sections = e;
        var name = element.name;
        // this.khaConfig.applyState_Sections(e, name,this.khaConfig.matrixDataList)
      }
    });
  }
  changeMatrixHullAll(e) {
    this.hullAllStatus = e;
    this.khaConfig.matrixDataList.forEach(element => {
      this.selectedDeck.forEach(ele => {
        element.hull = e;
      });
    })
    // this.khaConfig.applyState_Hull(e,'', this.khaConfig.matrixDataList)
  }
  changeMatrixbulkheadsAll(e) {
    this.bulkheadsAllStatus = e;
    this.khaConfig.matrixDataList.forEach(element => {
      this.selectedDeck.forEach(ele => {
        element.bulkheads = e;
      });
    })
    // this.khaConfig.applyState_Bulkheads(e,'', this.khaConfig.matrixDataList)
  }

  changeMatrixSectionsAll(e) {
    this.sectionsAllStatus = e;
    this.khaConfig.matrixDataList.forEach(element => {
      this.selectedDeck.forEach(ele => {
        element.sections = e;
      });
    })
    // this.khaConfig.applyState_Sections(e,'', this.khaConfig.matrixDataList)
  }
  // activeCard: any;
  // activeLayoutTag: any;
  // activeLayoutTagCard: any;
  // activeCards: any;
  // activeCardFlag = false;
  /**
   * clear preset system
   */
  clearPresetSystem(s) {
    this.current_preset = null;
    const idx = this.comps.findIndex(el => el.component.toLowerCase() === 'presets');

    this.comps[idx].compList.forEach(sys => {
      if (sys['name'] == s.name) {
        sys.selected = !true;
      }

    });
    this.broadcastInfo({ src: 'controlpanel', event: 'clear-system', data: s, key: '' });
  }
  /**
 * clear preset system
 */
  clearAllPresetSystem() {
    this.current_preset = null;
    const idx = this.comps.findIndex(el => el.component.toLowerCase() === 'presets');

    this.comps[idx].compList.forEach(sys => {
      // if (sys['code'] == s.code) {
      sys.selected = !true;
      this.broadcastInfo({ src: 'controlpanel', event: 'clear-system', data: sys, key: '' });
      // }
    });
    // this.broadcastInfo({ src: 'controlpanel', event: 'clear-system', data: s, key: '' });
  }
  /**
   * load preset system
   */
  current_preset = null
  processSystem(s) {
    if (this.current_preset === s.code) {
      return
    }
    let show = true;
    let returnValue = false;
    const idx = this.comps.findIndex(el => el.component.toLowerCase() === 'presets');

    this.comps[idx].compList.forEach(sys => {
      console.log("compList", s.code, sys['code'])
      if (sys['code'].sort().join(',').toLowerCase() == s.code.sort().join(',').toLowerCase()) {
        console.log("true", sys['code'] == s.code)
        sys.selected = true;
        show = true;
      }
    });
    this.current_preset = s.code
    this.broadcastInfo({ src: 'controlpanel', event: 'process-system', data: s, key: show });
  }

  filterdataComponentapply(data) {
    this.layoutCloseDetailData.tagPoints = []
    if (data.length != 0) {
      data.forEach(ele => {
        //this.groupJson.push({ "groupName": ele.groupName, "groupColor": ele.groupColor, isChecked: true, 'layoutId': ele.layoutId })
        if (this.layoutCloseDetailData._id == ele.layoutId) {
          this.layoutCloseDetailData.tagPoints.push(ele)
        }
      })
    }
    this.khaConfig.layoutFilterChanges(this.layoutCloseDetailData)
  }
  closeCompartmentList(sys) {
    sys.visiable = false;
    sys.selected = false;
    this.clearCompartmentList(sys)
    this.broadcastInfo({ src: 'sidepanel', event: 'deleteCompartments', data: sys });
  }
  // Start Status

  ToggleStatusOpenHanddle() {
    this.shipStatusHandleToggleOpen = !this.shipStatusHandleToggleOpen;
    if (!this.shipStatusHandleToggleOpen) {
      if (window.innerWidth > 541) {
      }
    }
    if (!this.shipStatusHandleToggleOpen) {
      var elem = document.getElementsByClassName('side_panel');
      elem[0].classList.remove('open');
    } else {
    }
  }

  // reconstrucuLayoutDataList:any=[];
  // reconstrucuLayoutData:any=[];
  // groupJsonData:any;
  // layoutJsonData:any;
  // activeTag: any;

  // reConstructTagJson(){
  //   if (this.sidepanelLayoutData.length != 0) {
  //     this.sidepanelGroupTagpoint = [];
  //     this.layoutJson = [];
  //     this.groupJson = [];
  //     this.statusFilter = [];
  //     this.sidepanelLayoutData.forEach((element, i) => {
  //       this.layoutJson.push({ 'layoutName': element.layoutName, 'layoutId': element._id, 'groupCollection': element.groupCollection, 'statusCollection': element.statusCollection, 'type': element.type, isChecked: true }) 
  //       element.tagPoints.forEach((tagpoint, idx) => {
  //         var tagpointIdx = element.Notes.findIndex(e => e.tagShapeId == tagpoint.tagShapeId)
  //         if(tagpointIdx > -1){
  //         element.Notes[tagpointIdx].startDate = this.datepipe.transform(element.Notes[tagpointIdx].startDate, "MMM d, y, h:mm a")
  //           tagpoint["tagComments"] =  element.Notes[tagpointIdx]
  //           tagpoint["layoutId"] = element._id;
  //         }
  //       this.groupJson.push({ "groupName": tagpoint.groupName, "groupColor": tagpoint.groupColor, isChecked: true, 'layoutId': element.layoutId })
  //       this.statusFilter.push({ "statusName": tagpoint['tagComments']['status']['statusName'], "statusColor": tagpoint['tagComments']['status']['statusColor'], isChecked: true, 'layoutId': element._id })
  //       this.sidepanelGroupTagpoint.push(tagpoint);
  //       })
  //     });
  //     console.log("this.sidepanelGroupTagpoint", this.sidepanelGroupTagpoint)
  //     this.reconstrucuLayoutDataList = this.sidepanelGroupTagpoint;
  //     this.reconstrucuLayoutData = this.sidepanelGroupTagpoint;
  //     this.filterLayoutJson = this.layoutJson;
  //     this.layoutJsonData = this.layoutJson;
  //     if(this.activeLayoutIndex> -1){
  //       var selectedLayout =  this.sidepanelLayoutData[this.activeLayoutIndex]
  //     } else {
  //       selectedLayout =[]
  //     }
  //     this.broadcastInfo({ src: 'sidepanel', event: 'layoutActive', data:  selectedLayout, tagShow : this.sidepanelGroupTagpoint, key: true });
  //     const ids = this.groupJson.map(o => o.groupName);
  //     this.groupJson = this.groupJson.filter(({ groupName }, index) => !ids.includes(groupName, index + 1));
  //     this.groupJsonData = this.groupJson
  //     const statusids = this.statusFilter.map(o => o.statusName);
  //     this.statusFilter = this.statusFilter.filter(({ statusName }, index) => !statusids.includes(statusName, index + 1));
  //     if(this.tagData){
  //       this.khaConfig.createMatObjectPoint(this.tagData,this.sidepanelGroupTagpoint[this.activeCard])
  //       this.khaConfig.matTagClear()
  //       this.khaConfig.showLayoutTag(this.tagData, true)
  //       this.activeCard = this.sidepanelGroupTagpoint.findIndex(tag => tag.tagShapeId == this.tagData.tagShapeId)
  //       this.activeTag = this.tagData.tagShapeId
  //     }
  //   } else {
  //     this.sidepanelGroupTagpoint = [];
  //     this.layoutJson = [];
  //     this.groupJson = [];
  //   }
  // }

  // createLayout() {
  //   this.broadcastInfo({ src: 'sidepanel', event: 'createLayout', });
  // }
  // createStatus() {
  //   this.broadcastInfo({ src: "sidepanel", event: "createStatus", data: "" })
  // }
  // editStatus(e) {
  //   this.broadcastInfo({ src: "sidepanel", event: "updateStatus", data: e })
  // }
  // // status color change
  // onChangeStatusColorClick(item) {
  //   this.StatusColorValue = item.value;
  // }
  // onChangeStatusColor(item, event) {
  //   console.log(item)
  //   item.value = event;
  //   this.configService.updateOodStatus(item._id, item).then(data => {
  //     if (data) {
  //       console.log("Status updated ", data);
  //       this.broadcastInfo({ src: "sidepanel", event: "updateStatusColor", data: "statusReload" })
  //     }
  //   }).catch((error) => {
  //     console.log("error ", error);
  //   });
  // }
  // delete status

  selectedStatusDeleteData = {};
  // OnDeleteStatus(i, item) {
  //   this.selectedStatusDeleteData = { i, item };
  //   this.broadcastInfo({ src: 'sidepanel', event: 'statusDelete', data: this.selectedStatusDeleteData, key: true });
  //   this.broadcastInfo({ src: 'material', event: 'openDialogConfirmStatusDelete', data: "", key: true });
  // }
  // deleteStatusData() {
  //   this.broadcastInfo({ src: 'sidepanel', event: 'statusDelete', data: this.selectedStatusDeleteData, key: true });
  // }

  // // Status search fuction
  // searchStatusData() {
  //   var filterData = [];
  //   if (this.searchStatus === '') {
  //     filterData = null;
  //     this.sidepanelStatusData = this.sidepanelStatusObject;
  //   } else {
  //     if (this.sidepanelStatusObject.length > 0) {
  //       for (let i = 0; i < this.sidepanelStatusObject.length; i++) {
  //         if (this.filterStatusKey.length > 0) {
  //           this.filterStatusKey.forEach((key) => {
  //             if (typeof this.sidepanelStatusObject[i][key] === 'string' && typeof this.searchStatus === 'string') {
  //               if (this.sidepanelStatusObject[i][key].toString().toLowerCase().indexOf(this.searchStatus.toLowerCase()) > -1) {
  //                 const found = filterData.some(el => el.group_id === this.sidepanelStatusObject[i]['group_id']);
  //                 if (!found) {
  //                   filterData.push(this.sidepanelStatusObject[i]);
  //                 }
  //               }
  //             }
  //           });
  //         }
  //       }
  //     }
  //     this.sidepanelStatusData = filterData;
  //   }
  // }
  // //  clear search
  // searchStatusClear() {
  //   this.searchStatus = "";
  //   this.sidepanelStatusData = this.sidepanelStatusObject;
  //   let filterdData = null;
  // }
  // createGroup() {
  //   this.broadcastInfo({ src: "sidepanel", event: "createGroup", data: "" })
  // }
  // editGroup(e) {
  //   this.broadcastInfo({ src: "sidepanel", event: "updateGroup", data: e })
  // }
  //   // Group search fuction
  //   searchGroupData() {
  //     var filterData = [];
  //     if (this.searchGroup === '') {
  //       filterData = null;
  //       this.sidepanelGroupData = this.sidepanelGroupObject;
  //     } else {
  //       if (this.sidepanelGroupObject.length > 0) {
  //         for (let i = 0; i < this.sidepanelGroupObject.length; i++) {
  //           if (this.filterGroupKey.length > 0) {
  //             this.filterGroupKey.forEach((key) => {
  //               if (typeof this.sidepanelGroupObject[i][key] === 'string' && typeof this.searchGroup === 'string') {
  //                 if (this.sidepanelGroupObject[i][key].toString().toLowerCase().indexOf(this.searchGroup.toLowerCase()) > -1) {
  //                   const found = filterData.some(el => el.group_id === this.sidepanelGroupObject[i]['group_id']);
  //                   if (!found) {
  //                     filterData.push(this.sidepanelGroupObject[i]);
  //                   }
  //                 }
  //               }
  //             });
  //           }
  //         }
  //       }
  //       this.sidepanelGroupData = filterData;
  //     }
  //     // this.mappingCategory();

  //     // this.sortByGrouplist(this.sortItem);
  //   }
  //   //  clear search
  //   searchGroupClear() {
  //     this.searchGroup = "";
  //     this.sidepanelGroupData = this.sidepanelGroupObject;
  //     let filterdData = null;
  //   }
  //   onChangeColor(item) {
  //     this.groupStatusColor = item.color;
  //   }
  //   onChange(item, event) {
  //     console.log(item)
  //     console.log()
  //     item.color = event;
  //     this.configService.updateOodGroup(item._id, item).then(reuslt => {
  //       this.broadcastInfo({ src: "sidepanel", event: "updateGroupColor", data: "groupReload" })
  //     })
  //     //this.khaConfig.hideHighlightSelection()
  //     this.broadcastInfo({ src: "sidepanel", event: "groupColorUpdated", data: item })
  //   }
  //   OnDeleteGroup(i, group) {
  //     this.selectedGroupDeleteData = { i, group };
  //     this.broadcastInfo({ src: 'material', event: 'openDialogConfirmGroupDelete', data: "", key: true });
  //   }
  //   deleteGroupData() {
  //     if (Object.keys(this.selectedGroupDeleteData).length === 0) return;
  //     let idx = this.selectedGroupDeleteData['i'];
  //     let groupID = this.selectedGroupDeleteData['group']['_id'] || ''
  //     if (groupID) {
  //       if (groupID === this.activeGroupIndex) {
  //         delete this.activeGroupIndex;
  //         this.broadcastInfo({ src: 'controlpanel', event: 'clear-group-window', data: "", key: true });
  //       }
  //       this.sidepanelGroupData.splice(idx, 1);
  //       this.broadcastInfo({ src: 'controlpanel', event: 'delete-group-data', data: groupID, key: '' });
  //       this.selectedGroupDeleteData = {};
  //     }
  //   }
  //   statusChange(data, layOut, tagpoint, status) {
  //     var statusId = this.sidepanelStatusData.filter(obj => obj.name == status)
  //     var statusIdData = statusId[0]._id;
  //     // this.broadcastInfo({ src: 'sidepanel', event: 'update-Status', data: statusId, });
  //     var layoutIDx = this.sidepanelLayoutData.findIndex(obj => obj._id == layOut)
  //     layOut = this.sidepanelLayoutData[layoutIDx]
  //     console.log('layout', layOut)
  //     var statusIDX = this.sidepanelStatusData.findIndex(obj => obj.name == status)
  //     var selectTag = layOut.tagPoints.filter(obj => obj.id == tagpoint.id)
  //     data.status = this.sidepanelStatusData[statusIDX]
  //     data.statusId = statusIdData;
  //     this.broadcastInfo({ src: 'comment', event: 'update-comment', data: data, "layOut": layOut, "selectTag": selectTag[0] });
  //   }
  //   deleteNotesConfirm(item){
  //     console.log(item)
  //     this.tagNotesDelete = item;
  //     this.broadcastInfo({ src: 'material', event: 'openDialogConfirmNotesDelete', data: "", key: true });
  //   }
  //   deleteNotesData(){
  //     this.broadcastInfo({ src: 'sidepanel', event: 'delete-notes-data', data: this.tagNotesDelete });
  //     // this.khaConfig.showHideTag(item, false);
  //     this.khaConfig.matTagClear()
  //     if(this.activeLayoutIndex){   
  //       this.broadcastInfo({ src: 'sidepanel', event: 'layoutActive', data:  this.sidepanelLayoutData[this.activeLayoutIndex], tagShow: this.sidepanelGroupTagpoint, key: true });
  //     }
  //     delete this.activeTag
  //   }
  //   activeSingleLayout(event, idxCard, layout , layoutIdx ,tag = undefined,item){
  //     this.activeLayoutId = layout;
  //     if(idxCard != this.activeCard){
  //       // this.khaConfig.createMatObjectPoint(tag,this.sidepanelGroupTagpoint[this.activeCard])
  //       this.tagServ.createMatTagObjectPoint(tag,this.sidepanelGroupTagpoint[this.activeCard])
  //       this.activeCard = idxCard;
  //       this.activeTag = tag.tagShapeId
  //     } else {
  //       this.tagServ.showHideTag(this.sidepanelGroupTagpoint[this.activeCard], true)
  //       // this.khaConfig.showLayoutTag(this.sidepanelGroupTagpoint[this.activeCard], true);
  //       delete this.activeCard
  //       delete this.activeTag
  //     }
  //     // this.drawService.clearCutOuts();
  //     // this.drawService.clearSections();
  //     // if(this.sidepanelLayoutData[layoutIdx].Marker.length != 0 && idxCard == this.activeCard){
  //     //    var marker = this.sidepanelLayoutData[layoutIdx].Marker.filter(marker => marker.markerId == tag.markerId);
  //     //    this.drawService.applyCutMarkersFromData(marker)
  //     // }
  //     this.sidepanelStatusData = item.statusCollection
  //     this.broadcastInfo({ src: 'sidepanel', event: 'updateCollectionData', data: item });
  //     this.broadcastInfo({ src: 'sidepanel', event: 'layoutActive', data: this.sidepanelLayoutData[layoutIdx], tagShow: this.sidepanelGroupTagpoint, key: true });
  //   }
  // activeSingleLaysout(event, idxCard, layout , layoutIdx ,tag = undefined,item){
  //   this.activeLayoutId = layout;
  //   if(idxCard != this.activeCard){
  //     this.tagServ.createMatTagObjectPoint(tag,this.sidepanelGroupTagpoint[this.activeCard])
  //     this.activeCard = idxCard;
  //     this.activeTag = tag.tagShapeId
  //   } else {
  //     this.tagServ.showHideTag(this.sidepanelGroupTagpoint[this.activeCard], true)
  //     delete this.activeCard
  //     delete this.activeTag
  //   }
  //   this.drawService.clearCutOuts();
  //   this.drawService.clearSections();
  //   this.activeLayoutIndex = layoutIdx
  //   if(this.sidepanelLayoutData[layoutIdx].Marker.length != 0 && idxCard == this.activeCard){
  //      var marker = this.sidepanelLayoutData[layoutIdx].Marker.filter(marker => marker.markerId == tag.markerId);
  //      this.drawService.applyCutMarkersFromData(marker)
  //   }
  //   this.sidepanelStatusData = item.statusCollection
  //   this.broadcastInfo({ src: 'sidepanel', event: 'updateCollectionData', data: item });
  //   this.broadcastInfo({ src: 'sidepanel', event: 'layoutActive', data: this.sidepanelLayoutData[layoutIdx], tagShow: this.sidepanelGroupTagpoint, key: true, activeTag:this.activeTag });
  // }

  // activeSingsleLayout(event, idxCard, layout , layoutIdx ,tag = undefined,item){
  //   this.activeLayoutId = layout;
  //   if(idxCard != this.activeCard){
  //     this.tagServ.createMatTagObjectPoint(tag,this.sidepanelGroupTagpoint[this.activeCard])
  //     this.activeCard = idxCard;
  //     this.activeTag = tag.tagShapeId
  //   } else {
  //     this.tagServ.showHideTag(this.sidepanelGroupTagpoint[this.activeCard], true)
  //     delete this.activeCard
  //     delete this.activeTag
  //   }
  //   this.drawService.clearCutOuts();
  //   this.drawService.clearSections();
  //   if(this.sidepanelLayoutData[layoutIdx].Marker.length != 0 && idxCard == this.activeCard){
  //      var marker = this.sidepanelLayoutData[layoutIdx].Marker.filter(marker => marker.markerId == tag.markerId);
  //      this.drawService.applyCutMarkersFromData(marker)
  //   }
  //   this.sidepanelStatusData = item.statusCollection
  //   this.broadcastInfo({ src: 'sidepanel', event: 'updateCollectionData', data: item });
  //   this.broadcastInfo({ src: 'sidepanel', event: 'layoutActive', data: this.sidepanelLayoutData[layoutIdx], tagShow: this.sidepanelGroupTagpoint, key: true });
  // }
  // openLayoutTag(event, i, layout, tag, tagIdx) {
  //   if (event) {
  //     if (event.target.classList.contains('status-change')) {
  //       return
  //     }
  //     if (event.target.classList.contains('Notes_delete_icon')) {
  //       return
  //     }
  //   }
  //   this.activeLayoutTag = layout;
  //   this.activeLayoutTagCard = tag;
  //   // this.activeCard = tagIdx;
  //   this.activeTag = tag.tagShapeId;
  //   this.khaConfig.showLayoutTagData = tag;
  //   this.khaConfig.showLayoutTagDataIdx = tagIdx;
  //   // this.activeCardFlag = true;
  //   this.layoutTagHide(i);

  //   let idx = this.sidepanelGroupTagpoint.findIndex(e => e._id == tag['_id']);
  //   if (this.activeLayoutIndex != undefined) {
  //     if (this.layoutJson[this.activeLayoutIndex]['layoutId'] == layout) {
  //       if (this.sidepanelGroupTagpoint[idx]['tagShowState']) {
  //         this.sidepanelGroupTagpoint[idx]['tagShowState'] = false;
  //         this.broadcastInfo({ src: 'material', event: 'layoutTagOpen', data: tag, status: false });
  //         delete this.activeTag;
  //         this.layoutTagState = false
  //       } else {
  //         this.sidepanelGroupTagpoint[idx]['tagShowState'] = true;
  //         this.broadcastInfo({ src: 'material', event: 'layoutTagOpen', data: tag, status: true });
  //         this.activeTag = tag.tagShapeId;
  //         this.layoutTagState = true
  //       }
  //     } else {
  //       this.activeLayout(this.activeLayoutIndex, this.layoutJson[this.activeLayoutIndex]['layoutId'], true);
  //       // setTimeout(() => {
  //       this.layoutLoadFromNote(event, i, layout, tag)
  //       // }, 1000);        
  //     }
  //   } else {
  //     this.layoutLoadFromNote(event, i, layout, tag)
  //   }
  //   // if (this.sidepanelLayoutData) {
  //   //   this.sidepanelLayoutData.forEach(element => {
  //   //     if (element['_id'] == layout) {
  //   //       const found = tag.name.split("_")
  //   //       if (found[0] == 'marker') {
  //   //         if ( element['markers'].length > 0) {
  //   //           var markerData = element['markers'].filter(m => m.uid+'_slicer' == tag.name);
  //   //           // element['markers'].forEach(ele => {
  //   //             if (markerData[0] == undefined || markerData[0].uid+'_slicer' != tag['name']) {
  //   //               this.broadcastInfo({ src: 'coursePanel', event: 'openDialog', data: "Marker failed to save. Please delete and recreate." });
  //   //             }
  //   //           // });
  //   //         } else {
  //   //           this.broadcastInfo({ src: 'coursePanel', event: 'openDialog', data: "Marker failed to save. Please delete and recreate." });
  //   //         }
  //   //       }
  //   //     }
  //   //   });
  //   // }
  // }
  // layoutLoadFromNote(event, i, layout, tag) {
  //   this.activeLayout(i, layout, true);
  //   // this.broadcastInfo({ src: 'material', event: 'layoutTagOpen', data: tag,status:true });
  //   setTimeout(() => {
  //     if (this.sidepanelLayoutData.length > 0) {
  //       this.sidepanelLayoutData.forEach(element => {
  //         if (element['_id'] == layout) {
  //           element['tagPoints'].forEach(ele => {
  //             if (ele['_id'] != tag['_id']) {
  //               let idx = this.sidepanelGroupTagpoint.findIndex(e => e._id == tag['_id']);
  //               if (idx > -1) {
  //                 this.sidepanelGroupTagpoint[idx]['tagShowState'] = false;
  //                 this.broadcastInfo({ src: 'material', event: 'layoutTagClose', data: ele });
  //               } else {
  //                 this.sidepanelGroupTagpoint[idx]['tagShowState'] = true;
  //               }

  //             }
  //           });
  //         }
  //       });
  //       console.log("layoutLoadFromNote", this.sidepanelGroupTagpoint);
  //     }
  //   }, 2000);
  // }

  // OnDeleteLayout(i, layout) {
  //   var layoutIDx = this.sidepanelLayoutData.findIndex(obj => obj._id == layout)
  //   layout = this.sidepanelLayoutData[layoutIDx]
  //   this.selectedLayoutDeleteData = { i, layout };
  //   this.broadcastInfo({ src: 'material', event: 'openDialogConfirmLayoutDelete', data: "", key: true });
  // }
  // deleteLayoutData() {
  //   // console.log(this.selectedLayoutDeleteData)
  //   if (Object.keys(this.selectedLayoutDeleteData).length === 0) return;
  //   let idx = this.selectedLayoutDeleteData['i'] || -1;
  //   let layoutID = this.selectedLayoutDeleteData['layout']['_id'] || ''
  //   if (layoutID) {
  //     if (idx === this.activeLayoutIndex) {
  //       delete this.activeLayoutIndex;
  //       this.broadcastInfo({ src: 'controlpanel', event: 'clear-layout-window', data: "", key: true });
  //     }
  //     this.sidepanelLayoutData.splice(idx, 1);
  //     if(this.activeCard){
  //       this.khaConfig.showLayoutTag(this.sidepanelGroupTagpoint[this.activeCard], false);
  //       this.khaConfig.matTagClear();
  //     }
  //     this.broadcastInfo({ src: 'controlpanel', event: 'delete-layout-data', data: this.selectedLayoutDeleteData['layout'], key: '' });
  //     this.selectedLayoutDeleteData = {};
  //   }
  // }
  // typeAction(e, item){
  //   this.chitService.typeCollectionForm = '';
  //   this.broadcastInfo({ src: 'sidepanel', event: 'createCollectionTypeForm', data: e, key: item });
  // }
  // viewDataTypeDetails(e, id, item){
  //   this.chitService.typeCollectionForm = '';
  //   this.broadcastInfo({ src: 'sidepanel', event: 'viewCollectionTypeForm', data: e, key: id, key1: item });
  // }

  sysVisiableShow(sys) {
    this.clearCompartmentList(sys);
  }

  resetFilter() {
    this.selectedDeck = [];
    this.deckList.forEach(obj => {
      obj.deckSelected = false
    })
    this.structHull = 'solid';
    this.structDecks = 'solid';
    this.structBulkheads = 'solid';
    this.structSections = 'solid';
    this.structOtherDecks = 'clear';
    this.khaConfig.otherDecks = 'clear';
    this.khaConfig.struct_state_current = {
      "Hull": "solid",
      "Decks": "solid",
      "Bulkheads": "solid",
      "Sections": "solid"
    };
    this.activeSelectedDeck();
  }


  desckClose(i, value) {
    let idx = this.selectedDeck.findIndex(e => e === value);
    if (idx > -1) {
      this.selectedDeck.splice(idx, 1);
    }

    let index = this.deckList.findIndex(obj => obj.name == value)
    if (index > -1) {
      this.deckList[index].deckSelected = false;
    }
    this.activeSelectedDeck();
  }

  activeSelectedDeck() {
    var deckFliter = [];
    let deckMultiple = []
    this.selectedDeck.forEach(ele => {
      if (ele.indexOf('0') > -1) {
        deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 2).toLowerCase() == ele.toLowerCase());
        if (ele.toLowerCase() == "01") {
          let addComp = []
          addComp = this.shipComp['compList'].filter(element => element.code.includes("ZD") || element.code.includes("ZH-J"));
          console.log("01", addComp);
          deckFliter = deckFliter.concat(addComp);
        }
      } else {
        deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 1).toLowerCase() == ele.toLowerCase());
        if (ele.toLowerCase() == "1") {
          let addComp = []
          addComp = this.shipComp['compList'].filter(element => element.code.includes("ZA-C") || element.code.includes("ZE-G") || element.code.includes("ZK-M"));
          console.log("01", addComp);
          deckFliter = deckFliter.concat(addComp);
        }
      }
      if (deckMultiple.length > 0) {
        deckMultiple = deckMultiple.concat(deckFliter)
      } else {
        deckMultiple = deckFliter;
      }
    });
    console.log(deckMultiple)
    this.compartmentDeckList = deckMultiple;
    this.compartmentList = deckMultiple;
    this.search = "";
    this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: this.selectedDeck, key: "" });
    this.deckSelectionCheckClear();
  }
}
